@if (hasData()) {
  <div
    echarts
    role="img"
    [options]="chartOptions()"
    [style.height.px]="height()"
    [attr.aria-label]="ariaLabel()"
  ></div>
}
